<script lang="ts">
    import {Select, Button, Modal, Toast, Tooltip} from 'svelma';
    import OptionsModal from "../presentational/OptionsModal.svelte";
    import OptionController from "../../application/SyllabusManager/controllers/OptionController.ts";
    import {writable} from "svelte/store";
    import {_} from "svelte-i18n";

    export let snapshots;
    export let selected;
    export let option;
    export let settings;
    export let languages;

    let sortedSnapshots;
    $: {
        if ($languages === 'hu') {
            sortedSnapshots = snapshots.sort((a, b) => {
                if (a.name_hu !== null || b.name_hu !== null) {
                    return a.name_hu.localeCompare(b.name_hu);
                }
            });
        } else {
            sortedSnapshots = snapshots.sort((a, b) => {
                if (a.name_en !== null || b.name_en !== null) {
                    return a.name_en.localeCompare(b.name_en);
                }
            });
        }
    }

    let optionManger = new OptionController(snapshots[$selected]);
    let modalActive = writable(false);
    let selectedModal = null;

    $: {
        optionManger = new OptionController(snapshots[$selected]);
        option.set(optionManger.getOption());
    }

    function toggleModal(selected) {
        selectedModal = selected;
        $modalActive = !$modalActive;
    }

    function closeModal() {
        Toast.create({message: $_('options.message'), type: 'is-info', position: 'is-top'});
        option.set($option);
    }

    function redirect() {
        window.location.href = "http://www.mik.pte.hu";
    }
</script>

<div class="p-2 columns is-gapless marginOff">
    <div class="column is-narrow pointer" on:click={redirect}>
        <div class="logo"></div>
    </div>
    <div class="column is-narrow has-text-white title has-text-centered-mobile">
        <div on:click={redirect} class="is-inline pointer">PTE</div>
        <div on:click={redirect} class="mik pointer">MIK</div>
        <div class="cursor is-inline has-text-centered-mobile">{$_('menubar.title')}</div>
    </div>
    <Tooltip label="{$_('menubar.message')}" type="is-info" position="is-right">
        <div class="help">beta</div>
    </Tooltip>
    <div class="column"></div>
    <div class="column is-narrow">
        <Select bind:selected={$languages} size="is-small" placeholder="Language" icon="globe" iconPack="fa" rounded>
            <option value="hu">{$_('menubar.hun')}</option>
            <option value="en">{$_('menubar.eng')}</option>
        </Select>
    </div>
</div>
<div class="p-2 columns">
    <div class="column is-one-fifth">
        <Select size="is-small" bind:selected={$selected} rounded expanded>
            {#each sortedSnapshots as snapshot,i}
                {#if $languages === 'hu'}
                    <option value={i}>{snapshot.name_hu}</option>
                {/if}
                {#if $languages === 'en'}
                    <option value={i}>{snapshot.name_en}</option>
                {/if}
            {/each}
        </Select>
    </div>
    <div class="column is-one-fifth">
        <Button size="is-small" iconPack="fa" iconRight="sliders" on:click={()=>toggleModal("option")}
                rounded>{$_('menubar.option')}</Button>
    </div>
</div>
<Modal bind:active={$modalActive} func={closeModal}>
    <OptionsModal optionStore={option} modalActive={modalActive}/>
</Modal>

<style>
    .mik {
        color: #0a2240;
        display: inline
    }

    .pointer {
        cursor: pointer;
    }

    .help {
        cursor: help
    }

    .cursor {
        cursor: default;
    }

    .marginOff {
        margin: 0 !important;
    }

    .title {
        line-height: 50px
    }

    .logo {
        background-image: url("/~web/logo_mik.png");
        width: 50px;
        height: 50px;
        background-size: cover;
        margin: auto 10px auto 10px;
    }
</style>